import { QueryKey, useQuery } from "react-query";
import { useSelector } from "react-redux";
import network from "../../../selectors/network";
import { getInspectionType } from "../../queries/inspection-types/getInspectionType";

export type GetInspectionTypeResponseBody = Awaited<ReturnType<ReturnType<typeof getInspectionType>>>;

export default function useInspectionType({ id, enabled = true }: { id: number | string; enabled?: boolean }) {
  const queryKey = InspectionTypeQueryKey({ id: id });
  const networkHeaders = useSelector(network.defaultHeaders);
  const inspectionTypeQuery = useQuery(queryKey, getInspectionType(networkHeaders), {
    enabled: id !== undefined && enabled,
    queryFnParamsFilter: (key) => [key[1]],
  });

  return {
    data: inspectionTypeQuery.data,
    key: queryKey,
    isLoading: inspectionTypeQuery.isLoading,
    isFetching: inspectionTypeQuery.isFetching,
  };
}

interface Params {
  id: string | number;
}
export function InspectionTypeQueryKey({ id }: Params): QueryKey {
  return ["inspection-type", id] as const;
}
